/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useErrorHandler } from 'react-error-boundary';

import { saveBusiness, clear } from '../../redux_toolkit/reserveSlice';
// import receptionRegister from '../../api/reception/receptionRegister';
import selectBusiness from '../../api/reserve/selectBusiness';
// import configMastaApi from '../../api/masta/configMasta';
import { useDidMount, useNavigateWithId } from '../../customHooks';
import TopicPath from '../../components/TopicPath';

import { saveConfig } from '../../redux_toolkit/rsvConfigSlice';
import rsvScnMastaApi from '../../api/masta/rsvScnMasta';
import rsvSettingMastaApi from '../../api/masta/rsvSettingMasta';

import { HOME_ONLY, PURPOSE_RSV, CANCEL_ANNOUNCE } from '../../constants';

import BackButton from '../../components/BackButton';

import MoveTop from "../../CommonParts"


// const funcCdBusiness = 'reception_business';

const HoverRecItemLabel = function ({ forId, recItemName, colorCd, checkedCheck = false }) {
  // const firstChecked = checkedCheck ? true : false;
  const firstChecked = !!checkedCheck;
  // const [isHovered, setIsHovered] = useState(false);
  const [isChecked, setIsChecked] = useState(firstChecked);

  const nonHoveredStyle = {
    border: `2px solid rgb(${colorCd})`,
  };

  const hoveredStyle = {
    border: `2px solid rgb(${colorCd})`,
    backgroundColor: `rgba(${colorCd}, 0.2)`,
  };

  // if (isHovered) {
  //   console.log('hover now');
  // }

  useEffect(() => {
    setIsChecked(!!checkedCheck);
  }, [checkedCheck]);

  return (
    <label
      htmlFor={forId}
      // style={isHovered || isChecked ? hoveredStyle : nonHoveredStyle}
      style={isChecked ? hoveredStyle : nonHoveredStyle}
    // onMouseEnter={() => setIsHovered(true)}
    // onMouseLeave={() => setIsHovered(false)}
    // onClick={() => setIsChecked(!isChecked)}
    >
      {recItemName}
    </label>
  );
};

const SelectBusiness = function () {
  const navigate = useNavigateWithId();
  // const location = useLocation();
  const handleError = useErrorHandler();

  const lgCd = useSelector((state) => state.reserve.lgCd);
  const storeBusiness = useSelector((state) => state.reserve.business);
  const storeRecItem = useSelector((state) => state.reserve.recItem);
  const rsvConfig = useSelector((state) => state.rsvConfig);
  const { topicPath = [], dispBusinessSelect = true } = rsvConfig;
  const isLoggedIn = useSelector((state) => state.login.accessToken);

  const dispatch = useDispatch();

  // const state = location?.state ?? '';
  // const receptionId = state.receptionId ?? '';

  // const isPaid = state.isPaid ?? false;
  // const attribute = useSelector((state) => state.function.receptionRegister);

  const [recItem, setRecItem] = useState([]);
  const [checkedRecItems, setCheckedRecItems] = useState([...storeRecItem]);
  const [business, setBusiness] = useState({ ...storeBusiness });
  const [pageName, setPageName] = useState('');
  const [backUrl, setBackUrl] = useState(null);
  const [locationSetting, setLocationSetting] = useState({});

  const [selectItemRange, setSelectItemRange] = useState({ min: 1, max: 1 });

  // business から指定IDのエントリを削除またはカウントデクリメントするヘルパー
  // count が 1 以下になる場合はキーごと削除し、変更前の business エントリが残らないようにする
  const decrementBusiness = (targetBusinessId, targetBusinessName) => {
    setBusiness((state) => {
      const prev = state[targetBusinessId];
      if (!prev || prev.count <= 1) {
        // この business の選択がすべて解除されたのでエントリ削除
        const next = { ...state };
        delete next[targetBusinessId];
        return next;
      }
      // まだ他の申請項目が選択されているのでカウントのみ減算
      return { ...state, [targetBusinessId]: { businessName: targetBusinessName, count: prev.count - 1 } };
    });
  };

  // 用件ボタン押下時の処理
  const onClickRecItem = (
    businessId,
    businessName,
    recItemId,
    recItemName,
    groupId,
    groupName,
    rsvSetId,
    formSetId
  ) => {
    const copy = [...checkedRecItems];
    const index = copy.findIndex((e) => e.recItemId === recItemId);

    if (index >= 0) {
      // チェック解除：checkedRecItems と business を両方更新
      copy.splice(index, 1);
      decrementBusiness(businessId, businessName);
    } else {
      if (selectItemRange.max !== null && copy.length >= selectItemRange.max) {
        // 上限に達している場合、先頭の選択を自動解除する
        // ※ 修正前は checkedRecItems のみ削除され、business に古いエントリが残っていた
        const [removed] = copy.splice(0, 1);
        if (removed) {
          decrementBusiness(removed.businessId, removed.businessName);
        }
      }
      copy.push({ recItemId, recItemName, businessId, groupId, groupName, rsvSetId, formSetId });
      setBusiness((state) => ({
        ...state,
        [businessId]: {
          businessName,
          // 関数型更新で最新の state を参照し、同一 business への複数選択にも対応
          count: (state[businessId]?.count ?? 0) + 1,
        },
      }));
    }

    setCheckedRecItems(copy);
  };

  const getRecItemList = async () => {
    // const { lgCd = '' } = lclGov;
    // 申請項目の取得
    try {
      const { business, selectItemMin, selectItemMax, locationSetting: ls = {} } = await selectBusiness.getRecItems(lgCd);
      setRecItem(business);
      setSelectItemRange({ min: selectItemMin, max: selectItemMax });
      setLocationSetting(ls);
    } catch (err) {
      window.alert('申請項目取得に失敗しました。');
      handleError(err);
    }
  };

  // 用件ボタンの作成
  const createRecItemTable = (business) => {
    const result = {};
    const businessKeys = Object.keys(business).sort(
      (a, b) => business[a].order - business[b].order
    );
    for (let h = 0; h < businessKeys.length; h += 1) {
      const businessId = businessKeys[h];
      const {
        business_name: businessName = '',
        groups: recItems = [],
        selectPageText = '',
      } = business[businessId];

      const tmpArray = [];
      tmpArray.push(
        <input id={`TAB-${businessId}`} type="radio" name="TAB" className="tabSwitch" />
      );
      tmpArray.push(
        <label className="tabLabel btn" htmlFor={`TAB-${businessId}`}>
          {businessName}
        </label>
      );
      result[businessId] = tmpArray;

      const objectKeys = Object.keys(recItems);
      const column = [];
      if (objectKeys.length > 0) {
        column.push(
          <p className="fs_18px">
            <strong>{selectPageText}</strong>
          </p>
        );
      }

      for (let i = 0; i < objectKeys.length; i += 1) {
        const {
          recItemGroupName = '',
          colorCd = '',
          items = [],
          groupId,
        } = recItems[objectKeys[i]];

        // 申請項目のないグループは表示しない
        if (items.length !== 0) {
          const buttonList = [];
          for (let j = 0; j < items.length; j += 1) {
            const {
              recItemId = '',
              recItemName = '',
              rsvSetId = null,
              formSetId = null,
            } = items[j];
            // eslint-disable-next-line eqeqeq
            const checkedCheck = checkedRecItems.find((elem) => elem.recItemId == recItemId);
            buttonList.push(
              <li>
                <input
                  type="checkbox"
                  id={`tab${businessId}g${i}_${j}`}
                  checked={checkedCheck}
                  onClick={() =>
                    onClickRecItem(
                      businessId,
                      businessName,
                      recItemId,
                      recItemName,
                      groupId,
                      recItemGroupName,
                      rsvSetId,
                      formSetId
                    )
                  }
                />
                <HoverRecItemLabel
                  forId={`tab${businessId}g${i}_${j}`}
                  recItemName={recItemName}
                  colorCd={colorCd}
                  checkedCheck={checkedCheck}
                />
              </li>
            );
          }

          const columnClassName = column.length % 2 === 1 ? 'group1' : 'group2';

          const tmpColumn = (
            <div className={colorCd === '' ? columnClassName : ''}>
              <h3 style={{ color: `rgb(${colorCd})` }}>{recItemGroupName}</h3>
              <ul className="row wrap">{buttonList}</ul>
            </div>
          );

          column.push(tmpColumn);
        }
      }
      if (column.length > 0) {
        result[businessId].push(<div className="tabContent">{column}</div>);
      }
    }

    // const businessIdList = Object.keys(result);
    let sortedResult = [];
    for (let k = 0; k < businessKeys.length; k += 1) {
      sortedResult = sortedResult.concat(result[businessKeys[k]]);
    }

    return sortedResult;
  };

  // パンくずリスト設定から、ページ名・前の画面のURLをstateに設定
  const getBackUrlAndPageName = (topicPathConf) => {
    const locationPath = window.location.pathname;
    const tmpPath1 = locationPath.replace('/reserve/', '');
    const tmpPath2 = tmpPath1.replace('/test', '');
    const currentPath = tmpPath2.replace('/demo', '');

    let backUrl = null;
    let scnName = '';
    for (let i = 0; i < topicPathConf.length; i += 1) {
      const { url = '', scnName: tmpScnName = '' } = topicPathConf[i];
      if (currentPath === url) {
        // 「前に戻る」先のURL取得
        const { url: tmpBackUrl = '' } = topicPathConf[i - 1];
        if (tmpBackUrl === '/:lgCd') {
          backUrl = `/${lgCd}`;
        } else {
          backUrl = `/${tmpBackUrl}`;
        }

        // pageNameを取得
        scnName = tmpScnName;

        break;
      }
    }

    setPageName(scnName);
    setBackUrl(backUrl);
  };

  const init = async () => {
    if (!dispBusinessSelect && !isLoggedIn) {
      navigate('/unregistered');
      return;
    }

    // ページ名/戻る先URLの取得
    getBackUrlAndPageName(topicPath);

    // 表示する用件情報の取得
    getRecItemList();
  };

  useDidMount(() => {
    init();
  });

  const onClickNext = async () => {
    if (checkedRecItems.length < selectItemRange.min) {
      window.alert(`用件を${selectItemRange.min}件選択してください。`);
      return;
    }
    if (selectItemRange.max !== null && checkedRecItems.length > selectItemRange.max) {
      window.alert(`用件は${selectItemRange.max}件まで選択できます。`);
      return;
    }

    const [item = ''] = checkedRecItems;
    const { rsvSetId = null, formSetId = null } = item;

    const rsvSetting = await rsvSettingMastaApi.getRsvSetting(rsvSetId);
    const {
      rsv_mode: mode = null,
      max_attendees: maxAttendees = 0,
      rsv_place: rsvPlaceIds = [],
      rsv_tell_place: rsvTelPlaceIds = [],
      tell_start: telStart = 3,
    } = rsvSetting;
    const rsvScnList = await rsvScnMastaApi.getRsvScn(mode, PURPOSE_RSV);

    const topicPathList = rsvScnList.map((obj) => ({
      url: obj.rsv_url,
      scnName: obj.scn_name,
    }));

    // dispatch(saveRsvMode({ rsvMode: mode }));
    // dispatch(saveTopicPath({ topicPath: topicPathList }));
    // dispatch(saveMaxAttendees({ maxAttendees }));
    dispatch(
      saveConfig({
        rsvMode: mode,
        topicPath: topicPathList,
        maxAttendees,
        rsvPlaceIds,
        rsvTelPlaceIds,
        telStart,
        locationSetting,
      })
    );

    // 用件が単一選択時で保存されており、申請項目IDが変更前と変更後で一致しない場合はreduxを削除する。
    if (
      selectItemRange.max !== null &&
      storeRecItem.length !== 0 &&
      storeRecItem[0].recItemId !== checkedRecItems[0].recItemId
    ) {
      dispatch(clear());
    }
    dispatch(saveBusiness({ business, recItem: checkedRecItems, rsvSetId, formSetId }));

    if (mode !== null && mode !== HOME_ONLY) {
      navigate('/place');
    } else {
      navigate('/date');
    }
  };

  // const getAttribute = (funcCd) => attribute[funcCd] ?? {};
  return (
    <>
      <TopicPath />
      <main>
        <article>
          <div id="contents">
            <MoveTop lgCd={lgCd} />
            <div className="inner">
              {/* <h2>STEP 1 利用用件の選択</h2> */}
              <h2>{pageName}</h2>
              <p className="txtCenter">
                用件を
                {selectItemRange.max === null
                  ? `${selectItemRange.min}件以上`
                  : `${selectItemRange.min}件`}
                選択してください。（必須）
              </p>
              <div className="row wrap tabArea">{createRecItemTable(recItem)}</div>
              <ul id="navi" className="row jcSB">
                <li className="col2">
                  <BackButton url={backUrl} />
                </li>
                <li className="col2 mr0 row jcFE">
                  <a
                    role="button"
                    // href="javascript:void(0);"
                    className="btn btNext"
                    onClick={onClickNext}
                    tabIndex={0}
                  >
                    入力内容を確定し次へ
                  </a>
                </li>
              </ul>
            </div>
            <div className='cancelAnnounce'>{CANCEL_ANNOUNCE}</div>
          </div>
        </article>
      </main>
    </>
  );
};

export default SelectBusiness;

HoverRecItemLabel.propTypes = {
  forId: PropTypes.string.isRequired,
  recItemName: PropTypes.string.isRequired,
  colorCd: PropTypes.string.isRequired,
  checkedCheck: PropTypes.bool.isRequired,
};
